// extracted by mini-css-extract-plugin
export default {"modalOverlay":"FD-z","modalContent":"GD-z","header":"HD-z","close":"ID-z"};